import { fileViewerAtom } from 'js/file_viewer/core/atoms/atom';
export const isFullScreenAtom = fileViewerAtom(false);
export const isDeleteFileModalOpenAtom = fileViewerAtom(false);
export const isTitleBarRenameActiveAtom = fileViewerAtom(false);
export const isSlideshowAtom = fileViewerAtom(false);
export const slideshowDelayMillisecondAtom = fileViewerAtom(5 * 1000);
export const isSlideshowPausedAtom = fileViewerAtom(false);
export const effectiveSlideshowDelayAtom = fileViewerAtom((get) => {
    const delay = get(slideshowDelayMillisecondAtom);
    const isPaused = get(isSlideshowPausedAtom);
    return isPaused ? undefined : delay;
});
const areToolsHiddenFullscreenAtom = fileViewerAtom(false);
const areToolsHiddenNonFullscreenAtom = fileViewerAtom(false);
export const areToolsHiddenAtom = fileViewerAtom((get) => {
    const isFullScreen = get(isFullScreenAtom);
    return isFullScreen ? get(areToolsHiddenFullscreenAtom) : get(areToolsHiddenNonFullscreenAtom);
}, (get, set, areToolsHidden) => {
    const isFullScreen = get(isFullScreenAtom);
    if (isFullScreen) {
        set(areToolsHiddenFullscreenAtom, areToolsHidden);
    }
    else {
        set(areToolsHiddenNonFullscreenAtom, areToolsHidden);
    }
});
//# sourceMappingURL=general.preenvesnextjs.map
